import * as T from "@shared/types";
import { AEROPRESS_VARIATIONS, VALID_AERO_PRESS_FOR_CONNECTION_GRIND } from "@client-shared/lib/constants";
import { mapByField } from "@client-shared/lib/map";

/**
 * Normalizes AeroPress grind type variations to a standard value.
 * Used for connection creation to ensure consistent grind type matching.
 */
export const sanitizeAeroPressGrind = (grindType: string) => {
  if (!AEROPRESS_VARIATIONS.includes(grindType)) {
    return grindType;
  }
  return VALID_AERO_PRESS_FOR_CONNECTION_GRIND;
};

/**
 * Groups all variants under their parent products.
 * Takes a list of products (potentially with single variants each) and
 * consolidates them so each product contains all its variants.
 */
export const setSingleParentProducts = (localProducts: T.Product[]): T.Product[] | undefined => {
  const productsMap = mapByField("id", localProducts);
  const keys = Array.from(productsMap.keys());
  const allVariants = localProducts.flatMap((product) => product.variants ?? []);
  const productsWithAllVariants = keys
    .map((key) => {
      const masterProduct = productsMap.get(key);
      if (!masterProduct) {
        return undefined;
      }
      const otherVariants = allVariants.filter(
        (variant) => variant !== masterProduct?.variants?.[0] && variant.productId === masterProduct?.id
      );
      return {
        ...masterProduct,
        variants: [...(masterProduct?.variants ?? []), ...otherVariants].filter((variant) => variant !== undefined),
      } satisfies T.Product;
    })
    .filter((product) => product !== undefined);
  return productsWithAllVariants;
};
